import { Component, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';
import { AuthenticatedUserService } from 'src/app/shared/services/authenticatedUser/authenticatedUser.service';

@Component({
    selector: 'app-logout',
    template: '',
    standalone: true
})
export class LogoutComponent implements OnInit {
    constructor(private authenticatedUserService: AuthenticatedUserService) {}

    ngOnInit(): void {
        this.authenticatedUserService.logout().pipe(take(1)).subscribe();
    }
}
